/* ============================================
   Folk Objects - API client (Shopify)
   Shared helper for talking to FolkServer.
   ============================================ */
(function (global) {
  'use strict';

  // TODO: replace with your deployed server URL
  var API_BASE = 'https://api.folkobjects.com';

  var TOKEN_KEY = 'folk_token';
  var USER_KEY = 'folk_user';

  function getToken() { return localStorage.getItem(TOKEN_KEY); }
  function setToken(t) { localStorage.setItem(TOKEN_KEY, t); }
  function clearToken() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  }
  function getUser() {
    try { return JSON.parse(localStorage.getItem(USER_KEY) || 'null'); }
    catch (e) { return null; }
  }
  function setUser(u) { localStorage.setItem(USER_KEY, JSON.stringify(u)); }

  function request(path, opts) {
    opts = opts || {};
    var method = opts.method || 'GET';
    var body = opts.body || null;
    var auth = opts.auth || false;

    var headers = { 'Content-Type': 'application/json' };
    if (auth) {
      var token = getToken();
      if (token) headers['Authorization'] = 'Bearer ' + token;
    }

    return fetch(API_BASE + path, {
      method: method,
      headers: headers,
      body: body ? JSON.stringify(body) : undefined
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && data.error) || 'Request failed (' + res.status + ')');
          err.status = res.status;
          err.data = data;
          throw err;
        }
        return data;
      }).catch(function (parseErr) {
        if (parseErr.status) throw parseErr;
        if (!res.ok) {
          var err2 = new Error('Request failed (' + res.status + ')');
          err2.status = res.status;
          throw err2;
        }
        return null;
      });
    });
  }

  var FolkAPI = {
    API_BASE: API_BASE,
    getToken: getToken,
    setToken: setToken,
    clearToken: clearToken,
    getUser: getUser,
    setUser: setUser,

    checkEmail: function (email) { return request('/auth/check-email?email=' + encodeURIComponent(email)); },
    signup: function (payload) { return request('/auth/signup', { method: 'POST', body: payload }); },
    loginRequest: function (email) { return request('/auth/login/request', { method: 'POST', body: { email: email } }); },
    verify: function (email, otp, purpose) { return request('/auth/verify', { method: 'POST', body: { email: email, otp: otp, purpose: purpose } }); },
    me: function () { return request('/auth/me', { auth: true }); },
    updateMe: function (patch) { return request('/auth/me', { method: 'PATCH', body: patch, auth: true }); },

    logout: function () { clearToken(); }
  };

  global.FolkAPI = FolkAPI;
})(window);
